export default "__VITE_ASSET__D7AMTu1w__"